import { render } from "./index.vue?vue&type=template&id=1dca79d2&bindings={}"
import script from "./DraggableNums.js?vue&type=script&lang=js"
export * from "./DraggableNums.js?vue&type=script&lang=js"

import "./DraggableNums.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script